import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import axios from "axios";
import bycard from "luu-ui";
import store from "@/store";
import router from "../router";
import { getToken, setToken } from "@/utils/auth";
import { codeEnum } from "../enum";
import i18n from "../i18n";
function updateToken(token) {
  store.commit("user/SET_TOKEN", token);
  setToken(token);
}
function handleError(code) {
  bycard.LuuToast({
    text: i18n.t("codes.code".concat(code)),
    uid: "codes.code".concat(code),
    type: "danger"
  });
}
console.log("----===", process.env);
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  // baseURL: 'https://customer-sandbox.bycard.io', // url = base url + request url
  timeout: 10000 // request timeout
});
service.interceptors.request.use(function (config) {
  var token = getToken();
  if (store.getters.token) {
    config.headers["authorization"] = token;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  if (response.data instanceof ArrayBuffer) {
    return response;
  }
  var token = response.headers.authorization;
  if (token) {
    updateToken(token); // keep the latest token
  }
  var res = response.data;
  if (res.code !== 0) {
    handleError(res.code);
    return Promise.reject(new Error(res.msg || "Error"));
  } else {
    return res;
  }
}, function (error) {
  var hasResCode = error.response && error.response.data && error.response.data.code;
  if (hasResCode) {
    var code = error.response.data.code;
    if ([codeEnum.noGa, codeEnum.tokenExpire, codeEnum.statusWrong].includes(code)) {
      handleError(code);
      store.dispatch("user/resetToken").then(function () {
        if (store.state.user.type === 4) {
          router.push("/login?type=person");
        } else {
          router.push("/login");
        }
      });
      return Promise.reject(error);
    }
  }
  handleError(404);
  return Promise.reject(error);
});
export default service;